import {styled} from "@mui/material";

export const DialogContentContainer = styled("div")(() => ({
    width: '100%',
    display: "flex",
    flexDirection: "column",
    alignItems: 'flex-start',
    justifyContent: "space-between",
    gap: '1rem'
}));

export const DialogContentItem = styled("div")(() => ({
    display: "flex",
    gap: '0.5rem',
    alignItems: 'center',
}));